import React, { lazy, Suspense } from 'react';
import BrandHeader from '../brandheader/BrandHeader';
import styles from './AgentListItem.less';
import AgentKpis from '../agentKpis/AgentKpis';
import { fetchListingsForRealtor } from '../../hooks/fetchListingsForRealtor';
import { AgentPictureWrapper } from '../agentpicture/AgentPictureWrapper';
import { isBasicBranchenbuchAgent, isBranchenbuchAgent } from '../../utils/AgentUtils';
import { CompanyName } from '../companyName/CompanyName';
import { AgentName } from '../agentname/AgentName';
import { AgentBadge } from '../agentBadge/AgentBadge';
import { ProfileStats } from '../profileStats/ProfileStats';
var TopListings = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "topListings" */'../agentlistings/TopListings');
});
var AgentListItem = function AgentListItem(_ref) {
  var agent = _ref.agent;
  var topListings = fetchListingsForRealtor(agent.agency.realtorCwid, agent.agency.agencyLookupName, agent.type);
  var company = agent.company,
    name = agent.name,
    salutation = agent.salutation,
    title = agent.title,
    type = agent.type,
    photoUrl = agent.photoUrl,
    agency = agent.agency;
  var totalNumberOfFollowers = agency.totalNumberOfFollowers,
    eligibleToBeFollowed = agency.eligibleToBeFollowed,
    oneSystemCustomer = agency.oneSystemCustomer,
    immoAwardWinner = agency.immoAwardWinner,
    immoAwardFinalist = agency.immoAwardFinalist;
  var basicAgentStyle = function basicAgentStyle(type) {
    return isBasicBranchenbuchAgent(type) ? styles.agentListItemOpacity : '';
  };
  var badges = company.badges;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.agentListItem, " ").concat(basicAgentStyle(type), " padding-top-m"),
    "data-testid": "agent-list-item"
  }, !isBasicBranchenbuchAgent(type) && !isBranchenbuchAgent(type) && /*#__PURE__*/React.createElement(BrandHeader, {
    company: company
  }, badges !== null && badges !== void 0 && badges.length ? /*#__PURE__*/React.createElement(AgentBadge, {
    badges: badges
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "padding-l background-white grid-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-item palm-one-whole"
  }, /*#__PURE__*/React.createElement(AgentPictureWrapper, {
    isBasicBranchenbuchAgent: isBasicBranchenbuchAgent(type),
    pictureUrl: photoUrl,
    badges: badges
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid-item grid-flex margin-bottom-xl lap-margin-horizontal-xl desk-margin-horizontal-xl des palm-margin-top-l",
    style: {
      flexFlow: 'column',
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(AgentName, {
    salutation: salutation,
    title: title,
    name: name
  }), /*#__PURE__*/React.createElement(CompanyName, {
    name: company.name
  }), /*#__PURE__*/React.createElement(ProfileStats, {
    evaluations: agent === null || agent === void 0 ? void 0 : agent.evaluations,
    followersCount: totalNumberOfFollowers,
    eligibleToBeFollowed: eligibleToBeFollowed,
    oneSystemCustomer: oneSystemCustomer,
    immoAwardWinner: immoAwardWinner,
    immoAwardFinalist: immoAwardFinalist
  }), /*#__PURE__*/React.createElement("div", {
    className: "margin-top-s palm-margin-top"
  }, /*#__PURE__*/React.createElement(AgentKpis, {
    kpis: agent.kpis
  }), topListings && topListings.length > 0 && /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      className: styles.listingsPlaceholder,
      "aria-hidden": "true"
    })
  }, /*#__PURE__*/React.createElement(TopListings, {
    topListings: topListings
  }))))));
};
export default AgentListItem;